<template>
  <div class="editor-tab-frame">
    <div v-if="loading && !loaded" class="ed-state">
      <v-progress-circular indeterminate color="primary" size="28"></v-progress-circular>
      <span>Carregando…</span>
    </div>

    <div v-if="loadError" class="ed-note ed-note--error mb-3">
      <i class="fal fa-exclamation-circle"></i>
      <div>
        Não foi possível carregar esta seção.
        <button type="button" class="ed-note__action" @click="$emit('reload')">Tentar novamente</button>
      </div>
    </div>

    <div v-if="conflictMessage" class="ed-note ed-note--warning mb-3">
      <i class="fal fa-exclamation-triangle"></i>
      <div>
        {{ conflictMessage }}
        <button type="button" class="ed-note__action" @click="$emit('reload')">Recarregar (descarta suas alterações)</button>
      </div>
    </div>

    <div v-if="loaded && !loadError">
      <slot></slot>

      <div v-if="editable" class="ed-actions" :class="{ 'ed-actions--dirty': dirty }">
        <div class="ed-actions__status">
          <span class="ed-actions__dot"></span>
          {{ dirty ? "Alterações não salvas" : "Tudo salvo" }}
        </div>
        <div class="ed-actions__buttons">
          <v-btn flat :disabled="!dirty || saving" @click="$emit('discard')">Descartar</v-btn>
          <v-btn
            depressed
            color="primary"
            class="ed-actions__save"
            :loading="saving"
            :disabled="!dirty || saving"
            @click="$emit('save')"
          >Salvar alterações</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Moldura comum das seções: carregando, erro de carga, conflito (409) e barra de ações fixa.
export default {
  name: "EditorTabFrame",
  props: {
    loading: Boolean,
    loaded: Boolean,
    loadError: Boolean,
    saving: Boolean,
    dirty: Boolean,
    conflictMessage: { type: String, default: null },
    editable: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.ed-note__action {
  display: block;
  margin-top: 6px;
  padding: 0;
  border: 0;
  background: none;
  font-weight: 600;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}
.ed-state {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
  justify-content: center;
  color: var(--ced-muted, #80849a);
}
.ed-actions {
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 20px;
  /* Espaço à direita para o botão flutuante de chat do app não cobrir "Salvar". */
  padding: 12px 88px 12px 20px;
  background: var(--ced-surface, #fff);
  border: 1px solid var(--ced-border, #e3e5ec);
  border-radius: var(--ced-radius, 10px);
  box-shadow: 0 -6px 18px rgba(76, 77, 79, 0.06);
}
.ed-actions__status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--ced-muted, #80849a);
}
.ed-actions__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #8cc63f;
}
.ed-actions--dirty .ed-actions__status {
  color: var(--ced-text, #4c4d4f);
  font-weight: 600;
}
.ed-actions--dirty .ed-actions__dot {
  background: var(--ced-warning, #e8a317);
}
.ed-actions__buttons {
  display: flex;
  align-items: center;
  gap: 4px;
}
.ed-actions__status {
  white-space: nowrap;
}
@media (max-width: 600px) {
  .ed-actions {
    flex-wrap: wrap;
    padding: 10px 76px 10px 14px;
    gap: 6px;
  }
  .ed-actions__status {
    width: 100%;
  }
  .ed-actions__buttons {
    width: 100%;
    justify-content: flex-end;
  }
}
.ed-actions__save {
  border-radius: 999px;
  padding: 0 20px;
  text-transform: none;
  font-weight: 600;
}
</style>
